import { cubeInstance } from "./cubeJsInstance";

export function checkAccessToken(store) {
  let accessToken = store.getters["authentication/getAccessToken"];

  if (!accessToken) {
    return false;
  }
  // Reinitialize whenever the token changes (e.g. after a user switch) so that
  // the previous user's cached Cube.js responses are never reused.
  if (!cubeInstance.instance || cubeInstance.currentToken !== accessToken) {
    cubeInstance.init(accessToken);
  }
  return true;
}

export function clearUserSession() {
  cubeInstance.instance = null;
  cubeInstance.currentToken = null;
}
